import React from 'react'
import { useSelector } from 'react-redux'
import CardDiagnosisProcedure from '../../../../../components/common/CardDiagnosisProcedure/CardDiagnosisProcedure'
import PanelCodeHistoryDisplay from '../sharedPanelComponents/PanelCodeHistoryDisplay'
import { isAIDiagnosis, isPrimaryAIDiagnosis } from '../sharedPanelComponents/sharedAIfunctions'

export default function PanelDiagnosisDisplay({
  dxTabList = [],
  onDxToggle,
  isHistory = false,
  showFav = false,
  hideSelectAll = false,
  dxHistory = [],
  onMassUpdate = () => {},
}) {
  const selectedDx = useSelector((state) => state.sidePanel.panelEncounter?.diagnosisCodes) || []
  const isReadOnly = useSelector((state) => state.sidePanel.isReadOnly)
  const features = useSelector((state) => state.user?.features) || []
  const coding_ai = useSelector((state) => state.sidePanel.panelEncounter?.coding_ai)
  const aiDxCodes = useSelector((state) => state.sidePanel.panelEncounter?.aiDxCodes)
  const aiMobileDiagnosisCodes =
    useSelector((state) => state.sidePanel.panelEncounter?.aiDiagnosisCodes) || []
  const service_date_from = useSelector(
    (state) => state.sidePanel.panelEncounter?.service_date_from,
  )

  const flatDxHistory = dxHistory.reduce((sum, obj) => [...sum, ...obj.dxs], [])
  const dxToModify = isHistory
    ? dxTabList.reduce((sum, obj) => [...sum, ...obj.dxs], [])
    : [...dxTabList]
  const allSelected = dxToModify.every((showDx) =>
    selectedDx.find((selDx) => selDx.code === showDx.code),
  )

  const onAllClick = (addAll) => {
    let newDx = [...selectedDx]
    if (!addAll) {
      // remove all
      newDx = newDx.filter((selDx) => !dxToModify.find((showDx) => selDx.code === showDx.code))
    } else {
      // add all
      const dxMap = {}
      selectedDx.forEach((dx) => {
        dxMap[dx.code] = dx.code
      })
      dxToModify.forEach((dx) => {
        if (!dxMap[dx.code]) {
          dxMap[dx.code] = dx.code
          newDx.push(dx)
        }
      })
    }

    onMassUpdate(newDx)
  }

  const mapDX = (dxList) => {
    return dxList.map((resultDx, index) => {
      const dxDisplayTags = []
      if (
        isAIDiagnosis(
          coding_ai,
          [...(aiDxCodes || []), ...aiMobileDiagnosisCodes],
          features,
          resultDx?.code,
        )
      ) {
        if (isPrimaryAIDiagnosis(coding_ai, features, resultDx?.code, aiMobileDiagnosisCodes)) {
          dxDisplayTags.push('ai-suggested primary dx')
        } else {
          dxDisplayTags.push('ai')
        }
      }

      if (flatDxHistory.find((dx) => dx.code === resultDx?.code)) {
        dxDisplayTags.push('previous')
      }
      return (
        <div key={'dx-display-' + index} style={{ pointerEvents: isReadOnly ? 'none' : '' }}>
          <CardDiagnosisProcedure
            item={resultDx}
            index={index}
            handleAddRemove={onDxToggle}
            serviceDate={service_date_from}
            icon={!selectedDx?.find((dx) => dx.code === resultDx.code) ? 'plus' : 'minus'}
            toggleFavorite={showFav}
            type={'DIAGNOSIS'}
            isAI={isAIDiagnosis(
              coding_ai,
              [...(aiDxCodes || []), ...aiMobileDiagnosisCodes],
              features,
              resultDx?.code,
            )}
            dxDisplayTags={dxDisplayTags}
          />
        </div>
      )
    })
  }

  return (
    <div className={'PanelDiagnosisDisplay'}>
      {dxTabList?.length > 0 ? (
        <div className="display-div">
          {!hideSelectAll && !isReadOnly && (
            <div className="d-flex justify-content-end pe-3 gap-2">
              <label className={'d-flex align-items-center'}>Select All </label>
              <input
                type="checkbox"
                checked={allSelected}
                onChange={() => onAllClick(!allSelected)}
              />
            </div>
          )}
          {isHistory
            ? dxTabList.map(({ date, dxs }, index) => (
                <React.Fragment key={'dx-history-display-' + index}>
                  <PanelCodeHistoryDisplay date={date} codes={dxs} display={mapDX} />
                  {index < dxTabList?.length - 1 && <hr style={{ marginBottom: '0' }} />}
                </React.Fragment>
              ))
            : mapDX(dxTabList)}
        </div>
      ) : (
        <div id="no-results">
          <p>No results found</p>
        </div>
      )}
    </div>
  )
}
